import { SAVE_VENDOR_INFO, LOGIN_VENDOR } from '../constants/actionTypes';

const doSaveVendorInfo = vendorInfo => ({
  type: SAVE_VENDOR_INFO,
  payload: vendorInfo,
});

const doLoginVendor = vendorInfo => ({
  type: LOGIN_VENDOR,
  payload: vendorInfo,
});

export { doSaveVendorInfo, doLoginVendor };
